'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _clientLibrary = require('@seneca/client-library');

var _Memory = require('./models/Memory');

var _Memory2 = _interopRequireDefault(_Memory);

var _Location = require('./models/Location');

var _Location2 = _interopRequireDefault(_Location);

var _LocationsPage = require('./models/LocationsPage');

var _LocationsPage2 = _interopRequireDefault(_LocationsPage);

var _MemoriesPage = require('./models/MemoriesPage');

var _MemoriesPage2 = _interopRequireDefault(_MemoriesPage);

var _LocationDoesNotExistError = require('./errors/LocationDoesNotExistError');

var _LocationDoesNotExistError2 = _interopRequireDefault(_LocationDoesNotExistError);

var _LocationBodyNotValidError = require('./errors/LocationBodyNotValidError');

var _LocationBodyNotValidError2 = _interopRequireDefault(_LocationBodyNotValidError);

var _MemoryDoesNotExistError = require('./errors/MemoryDoesNotExistError');

var _MemoryDoesNotExistError2 = _interopRequireDefault(_MemoryDoesNotExistError);

var _MemoryBodyNotValidError = require('./errors/MemoryBodyNotValidError');

var _MemoryBodyNotValidError2 = _interopRequireDefault(_MemoryBodyNotValidError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DEFAULT_FETCH_ALL_LIMIT = 2000;

/**
 * MemoryServiceClient
 * @param {Object} options options object input data and dependency injection
 * @param {Object} options.fetch change fetch method from whatwg-fetch (optional, default: whatwg-fetch)
 * @param {string} options.courseId saves entering courseId required for some methods
 * @param {string} options.protocol the http protocol of the service endpoint
 * @param {string} options.host the host of the service endpoint
 * @param {string} options.path the path of the service endpoint (optional)
 * @param {number} options.retries the number of times the client should retry on network error / service error (optional, default: 3)
 * @param {number} options.delayInSecs the delay between retries (optional, default: 2)
 * @param {Object} options.credentials identifiers and secrets required to hit protected endpoints (optional)
 * @param {string} options.region states the region of the service for signing (optional, default: eu-west-1)
 * @param {RequestMaker} options.requestMaker for overriding request making logic (optional, default: RequestMaker)
 * @throws {UrlConstructionError} when either options.protocol or options.host is missing
 */
class MemoryServiceClient extends _clientLibrary.Client {
  constructor(fetch, options) {
    super(fetch, options);
  }

  /**
   * Fetches all location paging as necessary to get them all.
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @returns {Promise.<[Location]>} the location object
   */
  async fetchAllLocations(_ref = {}) {
    let {
      limit = DEFAULT_FETCH_ALL_LIMIT
    } = _ref,
        otherOptions = (0, _objectWithoutProperties3.default)(_ref, ['limit']);

    let locations = [];
    let lastKey = undefined;
    do {
      const page = await this.fetchPageOfLocations((0, _extends3.default)({
        lastKey,
        limit
      }, otherOptions));
      lastKey = page.lastKey;
      locations = locations.concat(page.items);
    } while (lastKey);

    return locations;
  }

  /**
   * Fetches a single page of locations.
   * @param {Object} options - optional {limit, lastKey}
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @returns {Promise.<[LocationsPage]>} the location object
   */
  async fetchPageOfLocations(options) {
    const query = {};
    options.limit && (query.limit = options.limit);
    options.lastKey && (query.lastKey = options.lastKey);
    return await this._makeLocationRequest('GET', null, null, query);
  }

  /**
   * Fetches a single location by id.
   * @param {string} locationId - the id of the location to fetch.
   * @throws {MissingParamError} when the locationId is missing
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @throws {LocationDoesNotExistError} when the location cant be found.
   * @returns {Promise.<Location>} the location object
   */
  async fetchLocation(locationId) {
    if (!locationId) {
      throw new _clientLibrary.MissingParamError('locationId');
    }
    return await this._makeLocationRequest('GET', locationId, null);
  }

  /**
   * Creates a new location
   * @param {Object} location
   * @throws {MissingParamError} when the location object is missing
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @throws {LocationBodyNotValidError} when the location payload was invalid and could not be updated
   * @returns {Promise.<undefined>} the new location including generated ids.
   */
  async createLocation(location) {
    if (!location) {
      throw new _clientLibrary.MissingParamError('location');
    }
    return await this._makeLocationRequest('POST', null, location);
  }

  /**
   * Updates an existing location
   * @param {Object} location - contains only fields to be updated.
   * @param {string} locationId - the id of the location to update.
   * @throws {MissingParamError} when the location object or locationId is missing
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @throws {LocationDoesNotExistError} when the location cant be found.
   * @throws {LocationBodyNotValidError} when the location payload was invalid and could not be updated.
   * @returns {Promise.<Location>} the updated location response
   */
  async updateLocation(location, locationId) {
    if (!location) {
      throw new _clientLibrary.MissingParamError('location');
    }
    if (!locationId) {
      throw new _clientLibrary.MissingParamError('locationId');
    }
    return await this._makeLocationRequest('PATCH', locationId, location);
  }

  /**
   * Deletes an existing location
   * @param {string} locationId - the id of the location to delete.
   * @throws {MissingParamError} when the locationId is missing
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @throws {LocationDoesNotExistError} when the location cant be found.
   * @returns {Promise.<undefined>}
   */
  async deleteLocation(locationId) {
    if (!locationId) {
      throw new _clientLibrary.MissingParamError('locationId');
    }
    return await this._makeLocationRequest('DELETE', locationId, null);
  }

  async _makeLocationRequest(method, locationId, body, queryParams) {
    const url = this.url + (locationId ? `/api/locations/${locationId}` : '/api/locations') + (queryParams && (0, _keys2.default)(queryParams).length > 0 ? '?' + _queryString2.default.stringify(queryParams) : '');
    const expectedResponses = [200, 201, 204, 404, 422];
    const response = await this.requestMaker.makeRequest(url, {
      method,
      body: body ? (0, _stringify2.default)(body) : undefined
    }, expectedResponses);

    if (response.status === 404) {
      throw new _LocationDoesNotExistError2.default(locationId);
    }
    if (response.status === 422) {
      const body = response.json;
      throw new _LocationBodyNotValidError2.default(body.pointer, body.reason);
    }
    if (response.status === 200 || response.status === 201) {
      const body = response.json;
      return body.items ? new _LocationsPage2.default(body) : new _Location2.default(body);
    }
    // else 204 no exception or response body
  }

  /**
   * Fetches all memories paging as necessary to get them all.
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @returns {Promise.<[Memory]>} the memory objects
   */
  async fetchAllMemories(_ref2 = {}) {
    let {
      limit = DEFAULT_FETCH_ALL_LIMIT
    } = _ref2,
        otherOptions = (0, _objectWithoutProperties3.default)(_ref2, ['limit']);

    let locations = [];
    let lastKey = undefined;
    do {
      const page = await this.fetchPageOfMemories((0, _extends3.default)({
        lastKey,
        limit
      }, otherOptions));
      lastKey = page.lastKey;
      locations = locations.concat(page.items);
    } while (lastKey);

    return locations;
  }

  /**
   * Fetches a single page of memories.
   * @param {Object} options - optional {limit, lastKey}
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @returns {Promise.<[MemoriesPage]>} the memory objects
   */
  async fetchPageOfMemories(options) {
    const query = {};
    options.limit && (query.limit = options.limit);
    options.lastKey && (query.lastKey = options.lastKey);
    return await this._makeMemoryRequest('GET', null, null, query);
  }

  /**
   * Fetches a single memory by id.
   * @param {string} memoryId - the id of the memory to fetch.
   * @throws {MissingParamError} when the memoryId is missing
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @throws {MemoryDoesNotExistError} when the memory cant be found.
   * @returns {Promise.<Memory>} the memory object
   */
  async fetchMemory(memoryId) {
    if (!memoryId) {
      throw new _clientLibrary.MissingParamError('memoryId');
    }
    return await this._makeMemoryRequest('GET', memoryId, null);
  }

  /**
   * Creates a new memory
   * @param {Object} memory
   * @throws {MissingParamError} when the memory object is missing
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @throws {MemoryBodyNotValidError} when the memory payload was invalid and could not be updated
   * @returns {Promise.<Memory>} the new memory including generated ids.
   */
  async createMemory(memory) {
    if (!memory) {
      throw new _clientLibrary.MissingParamError('memory');
    }
    return await this._makeMemoryRequest('POST', null, memory);
  }

  /**
   * Updates an existing memory
   * @param {Object} memory - contains only fields to be updated.
   * @param {string} memoryId - the id of the memory to update.
   * @throws {MissingParamError} when the memory object or memoryId is missing
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @throws {MemoryDoesNotExistError} when the memory cant be found.
   * @throws {MemoryBodyNotValidError} when the memory payload was invalid and could not be updated.
   * @returns {Promise.<Memory>} the updated memory response
   */
  async updateMemory(memory, memoryId) {
    if (!memory) {
      throw new _clientLibrary.MissingParamError('memory');
    }
    if (!memoryId) {
      throw new _clientLibrary.MissingParamError('memoryId');
    }
    return await this._makeMemoryRequest('PATCH', memoryId, memory);
  }

  /**
   * Deletes an existing memory
   * @param {string} memoryId - the id of the memory to delete.
   * @throws {MissingParamError} when the memoryId is missing
   * @throws {UnexpectedServerResponse} when service returns an unexpected response
   * @throws {RequestLimitExceeded} when the max number of retries has been hit
   * @throws {MemoryDoesNotExistError} when the memory cant be found.
   * @returns {Promise.<undefined>}
   */
  async deleteMemory(memoryId) {
    if (!memoryId) {
      throw new _clientLibrary.MissingParamError('memoryId');
    }
    return await this._makeMemoryRequest('DELETE', memoryId, null);
  }

  async _makeMemoryRequest(method, memoryId, body, queryParams) {
    const url = this.url + (memoryId ? `/api/memories/${memoryId}` : '/api/memories') + (queryParams && (0, _keys2.default)(queryParams).length > 0 ? '?' + _queryString2.default.stringify(queryParams) : '');
    const expectedResponses = [200, 201, 204, 404, 422];
    const response = await this.requestMaker.makeRequest(url, {
      method,
      body: body ? (0, _stringify2.default)(body) : undefined
    }, expectedResponses);
    if (response.status === 404) {
      throw new _MemoryDoesNotExistError2.default(memoryId);
    }
    if (response.status === 422) {
      const body = response.json;
      throw new _MemoryBodyNotValidError2.default(body.pointer, body.reason);
    }
    if (response.status === 200 || response.status === 201) {
      const body = response.json;
      return body.items ? new _MemoriesPage2.default(body) : new _Memory2.default(body);
    }
    // else 204 no exception or response body
  }
}
exports.default = MemoryServiceClient;